module.exports = __webpack_public_path__ + "img/amaxz.725b4b5b.png";